/**
 * Rótulos compartilhados das opções de exportação.
 *
 * As configurações devem referenciar estas chaves como `dic.exporter.*`,
 * evitando textos de interface hardcoded nos módulos e tutoriais.
 */
export default {
  listCsv: 'Lista CSV',
  listXlsx: 'Lista XLSX',
  listDocx: 'Lista DOCX',
  listPdf: 'Lista PDF',
  listOf: 'Lista de',
  page: 'Página',
  of: 'de',
  pagination: 'Página %s de %s',
  generatedBy: 'Gerado por',
  institutional: 'Núcleo P - Tecnologia e Gestão',
  slogan: 'Menos discurso, mais resultado.',
};
